import i18n from '@dms/i18n';
import {getLocaleLanguageLabel} from '@dms/shared';

export function getTermsAndConditionsLabel(locale: string): string {
  return `${i18n.t('entity.warranty.labels.termsAndConditions')} [${getLocaleLanguageLabel(locale)}]`;
}
